export enum LeadOverviewTabKeys {
    OVERVIEW_KEY = 'OVERVIEW',
    ASSET_CLASSIFICATION_KEY = 'ASSET_CLASSIFICATION',
    DETAILS = 'DETAILS',
    SUMMARY_KEY = 'SUMMARY',
    TASKS_KEY = 'TASKS',
    MEETINGS_KEY = 'MEETINGS',
    CONTACTS_KEY = 'CONTACTS',
    AGREEMENTS_KEY = 'AGREEMENTS',
    ATTACHMENTS_KEY = 'ATTACHMENTS',
    RELATED_INFORMATION_KEY = 'RELATED_INFORMATION_KEY'
}
